import React, {useState} from "react";
import { authService } from '../../services/auth.service';
import { useFormik } from 'formik';
import Layout from '../../components/Layout';
import { useTurnstile } from '../../hooks/useTurnstile.hook';
import { TURNSTILE_HEADER } from '../../helpers/turnstile';
import { extractErrorMessage } from '../../helpers/errorHandler';
import circles_contact from '../../assets/icons/circles_contact.svg';
import elipse_contact from '../../assets/icons/elipse_contact.svg';
import checkMark from '../../assets/icons/check-mark.svg';
import girlContact from '../../assets/images/girl_contact_resized.png';
import '../../Styles/Contact.scss';

const Contact = () => {
  const [error, setError] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const { containerRef, token, status, reset, isVerified } = useTurnstile();
  const showCaptcha = status !== 'disabled';

  const formik = useFormik({
    initialValues: {
      email: '',
      fullName: '',
      message: ''
    },
    onSubmit: async (values) => {
      if (!isVerified) {
        setError(
          status === 'error'
            ? 'Verification is unavailable, so your message cannot be sent. Please disable your ad blocker or reload the page.'
            : 'Verification is still in progress. Please try again in a moment.'
        );
        return;
      }

      try {
        setError('');
        await authService.sendMessage(
          values.email,
          values.fullName,
          values.message,
          'Contact Us',
          token ? { headers: { [TURNSTILE_HEADER]: token } } : undefined
        );
        setSubmitted(true);
      } catch(err: any) {
        setError(extractErrorMessage(err, 'Your message could not be sent. Please try again.'));
      } finally {
        reset();
      }
    }
  });
  return (
    <Layout>
      <div className='contact__page'>
        <img src={circles_contact} alt="" className="circles_contact"/>
        <div className="contact__flex">
          <div className="form__contact">
            <img src={elipse_contact} alt="" className="elipse_contact"/>
            {
              submitted ? (
                <div className="contact__submitted">
                  <h2>Message Sent</h2>
                  <img src={checkMark} alt="" className="check_mark"/>
                  <p>Thank you for your message. We will get in contact with you as soon as possible.</p>
                </div>
              ) : (
                <form onSubmit={formik.handleSubmit}>
                  <div className="contact__header">
                    <h2>Contact us</h2>
                    <p>Your opinion matters a lot!</p>
                    <span className="contact__error">{error}</span>
                  </div>
                  <div className="contact__input">
                    <input type="email" name="email" required id="email" placeholder="Enter your email" onChange={formik.handleChange} value={formik.values.email} />
                    <input type="text" name="fullName" required id="fullName" placeholder="Enter your name" onChange={formik.handleChange} value={formik.values.fullName} />
                  </div>
                  <div className={`textarea__input${showCaptcha ? ' with-captcha' : ''}`}>
                    <p>Feedback</p>
                    <textarea name="message" id="message" required placeholder="Type your message" onChange={formik.handleChange} value={formik.values.message}></textarea>
                  </div>
                  {showCaptcha && (
                    <div className="contact__captcha">
                      {/* Usually empty - Turnstile only paints here when it needs a challenge. */}
                      <div ref={containerRef}></div>
                      <span className="contact__captcha-note">
                        Protected by Cloudflare Turnstile.{' '}
                        <a href="https://www.cloudflare.com/privacypolicy/" target="_blank" rel="noreferrer">Privacy</a>
                        {' · '}
                        <a href="https://www.cloudflare.com/website-terms/" target="_blank" rel="noreferrer">Terms</a>
                      </span>
                    </div>
                  )}
                  <button type="submit" disabled={formik.isSubmitting}>Send</button>
                </form>
              )
            }
          </div>
        </div>
        <div className="contact__img">
          <img src={girlContact} alt="" className="girlContact"/>
        </div>
      </div>
    </Layout>
  );
}

export default Contact;
